export const testAttributes = {
    MENU_WRAPPER: 'menu-wrapper',
    MENU_CONTAINER: 'menu-container-',
    MENU_HEADING: 'menu-heading-',
    MENU_LIST: 'menu-list-',
    MENU_ITEM: 'menu-item-',
};

export const compProps = [
    {
        databaseId: 29,
        label: 'Research Your Options',
        path: null,
        parentId: null,
        parentDatabaseId: 0,
        submenu: {
            nodes: [
                {
                    databaseId: 18,
                    label: "See Today's Rates",
                    path: 'https://www.quickenloans.com/mortgage-rates',
                },
                {
                    databaseId: 19,
                    label: "Home Buyer's Guide",
                    path: 'https://www.quickenloans.com/learn/should-i-buy-a-house',
                },
                {
                    databaseId: 20,
                    label: 'Refinance Guide',
                    path: 'https://www.quickenloans.com/learn/reasons-to-refinance-your-home',
                },
                {
                    databaseId: 21,
                    label: 'Try Our Calculators',
                    path: 'https://www.quickenloans.com/calculators',
                },
                {
                    databaseId: 22,
                    label: 'Learning Center',
                    path: 'https://www.quickenloans.com/learn',
                },
            ],
        },
    },
    {
        databaseId: 30,
        label: 'Learn About Quicken Loans',
        path: null,
        parentId: null,
        parentDatabaseId: 0,
        submenu: {
            nodes: [
                {
                    databaseId: 23,
                    label: 'About Us',
                    path: 'https://www.quickenloans.com/about',
                },
                {
                    databaseId: 24,
                    label: 'Contact Us',
                    path: 'https://www.quickenloans.com/about/contact',
                },
            ],
        },
    },
    {
        databaseId: 31,
        label: 'Follow us on Social',
        path: null,
        parentId: null,
        parentDatabaseId: 0,
        submenu: {
            nodes: [
                {
                    databaseId: 25,
                    label: 'Facebook',
                    path: 'https://www.facebook.com/QuickenLoans ',
                },
                {
                    databaseId: 26,
                    label: 'Instagram',
                    path: 'https://instagram.com/quickenloans',
                },
                {
                    databaseId: 27,
                    label: 'Twitter',
                    path: 'https://twitter.com/QuickenLoans',
                },
                {
                    databaseId: 28,
                    label: 'Pinterest',
                    path: 'https://www.pinterest.com/quickenloans/',
                },
            ],
        },
    },
];
